export const MY_FAVORITES_ACTIONS = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
}

export const MY_FAVORITES_STORAGE_PREFIX = 'favs_pending-action'
